module.exports = __webpack_public_path__ + "static/media/AM_Logo2.633f242d.png";